// extracted by mini-css-extract-plugin
export var byline = "bg_dv";
export var bylineItem = "bg_dw";